import styled from "styled-components";

export const Header = styled.div`
  text-align: center;
  font-size: 2rem;
  color: #071242;
  font-weight: 800;
  margin-bottom: 5rem;
`;

export const Subtitle = styled.div`
  margin-bottom: 3.5rem;
  color: #071242;
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 2.4rem;
`;

export const Title = styled.div`
  margin-bottom: 3rem;
  font-size: 2.5rem;
  line-height: 1.1;
  font-weight: 800;
  color: #071242;
`;
